// src/pages/RealEstateListPage.js

import styled from "styled-components";

import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";
import Products from "../components/Products";
import { useLocation } from "react-router";
import { useState } from "react";
import { useEffect } from "react";
const Container = styled.div``;

const Title = styled.h1`
  margin: 20px;
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Filter = styled.div`
  margin: 20px;
`;

const FilterText = styled.span`
  font-size: 20px;
  font-weight: 600;
  margin-right: 20px;
`;

const Select = styled.select`
  padding: 10px;
  margin-right: 20px;
`;

const Option = styled.option``;

// English-only Saudi cities
const saudiCities = [
  "Abha", "Abqaiq", "Abu Arish", "Ad Dilam", "Ad Darb", "Ad Dawadimi",
  "Afif", "Ahad Rifaydah", "Ain Dar", "Al Aflaj", "Al Ahsa (Hofuf)",
  "Al Ardah", "Al Artawiyah", "Al Awamiyah", "Al Badayea", "Al Bahah",
  "Al Batin", "Al Bukayriyah", "Al Dair", "Al Dayer", "Al Ghat", "Al Hada",
  "Al Hait", "Al Hassa", "Al Hufuf", "Al Jamum", "Al Jawf", "Al Jubail",
  "Al Kamil", "Al Khafji", "Al Kharj", "Al Khobar", "Al Khurmah", "Al Lith",
  "Al Majmaah", "Al Mandak", "Al Mithnab", "Al Muwayh", "Al Namas",
  "Al Omran", "Al Qaisumah", "Al Qatif", "Al Qurayyat", "Al Quwayiyah",
  "Al Rass", "Al Shinan", "Al Sulayyil", "Al Tuwal", "Al Ula", "Al Wajh",
  "Al Zulfi", "Anak", "Arar", "Ash Shafa", "Asfan", "Badr", "Baljurashi",
  "Baqa", "Bisha", "Buraidah", "Dammam", "Dhahran", "Dhurma", "Farasan",
  "Fifa", "Hafar Al Batin", "Hail", "Haql", "Hawtat Bani Tamim", "Jazan",
  "Jeddah", "Khamis Mushait", "Khaybar", "Khulais", "Layla",
  "Madinah (Medina)", "Mahd adh Dhahab", "Makkah (Mecca)", "Muhayil Aseer",
  "Najran", "Nariyah", "Onaizah", "Qunfudhah", "Rafha", "Ras Tanura",
  "Riyadh", "Sabya", "Sakaka", "Sharurah", "Shaqra", "Tabuk", "Taif",
  "Tanomah", "Turaif", "Umluj", "Wadi Ad Dawasir", "Yanbu", "Zulfi"
];

const RealEstateListPage = () => {
  const location = useLocation();
  const type = decodeURIComponent(location.pathname.split("/")[2]); // e.g. "Villa", "Land", etc.

  const [filters, setFilters] = useState({});

  useEffect(() => {
    document.title = `${type} Real Estate — SAUDIDUNES`;
  }, []);

  const handleFilters = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Container>
      

      <Title>{type.toUpperCase()}</Title>

      <FilterContainer>
        <Filter>
          <FilterText>Filter by City:</FilterText>

          <Select name="city" onChange={handleFilters}>
            <Option value="">Select City</Option>
            {saudiCities.map((city) => (
              <Option key={city} value={city}>
                {city}
              </Option>
            ))}
          </Select>
        </Filter>
      </FilterContainer>

      <Products
        mode="realestate"
        type={type}
        filters={filters}
      />

      <Newsletter />
      <Footer />
    </Container>
  );
};

export default RealEstateListPage;
